<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [max]="max" [control]="control" [label]="label" />
